var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app"},[(_vm.autenticado)?_c('div',{staticClass:"container-app"},[_c('Navbar'),_c('v-main',[_c('Alert'),_c('router-view')],1)],1):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }